import { atomWithReset } from "jotai/utils";

export type VirtualTourViewerModeName = "Orbit" | "Floorplan" | "VirtualTour";

export type VirtualTourViewerMode = {
  name: "Orbit",
  calledFrom: "main-toolbar"
} | {
  name: "Floorplan",
  calledFrom: "main-toolbar"
} | {
  name: "VirtualTour",
  calledFrom: "main-toolbar" | "click-hotspot"
}

export const currentVirtualViewerModeAtom =
  atomWithReset<VirtualTourViewerMode>({
    name: "Orbit",
    calledFrom: "main-toolbar",
  });
